module.exports = __webpack_public_path__ + "img/logo.13b855a5.png";